module.exports = __webpack_public_path__ + "static/media/icon-caret-right.e5466a6e.svg";